export const calculateTotalUnread = (unreadMessages: { [key: string]: number }): number => {
  return Object.values(unreadMessages).reduce((acc, count) => acc + count, 0);
};
